
<div class="order-ticket" style="padding:0.5rem 1rem 1rem; margin-bottom:0">

    <app-signup-banner _class="mb-2" [position]="'ticket'"></app-signup-banner>

    <div class="order-ticket-body" style="min-height: auto; box-shadow: none">

        <div class="ticket-box text-center">
            <h4>{{'PO.ORDER_NO' | translate}}:&nbsp;<span class="inline">{{$storage.order.printData.variables.ORDER_NO}}</span></h4>
            <hr />
        </div>

		@if (!isUS) {
			<div class="ticket-box" *ngIf="$storage.showPrices">
				@if (appService.regionArgs.showDetailedFees && $storage.order.printData?.collections?.FEES[0]) {
					<table class="ticket-box-table mb-2">
						<tr>
							<th>{{ 'Subtotal' | translate }}</th>
							<td>{{ $storage.order.printData.variables.INCLUSIVE_NET_AMOUNT | number:'1.2-2' }}</td>
						</tr>

						@for (fee of $storage.order.printData?.collections?.FEES; track fee) {
							<tr>
								<th>{{ fee.NAME }}</th>
								<td>{{ fee.AMOUNT | number:'1.2-2' }}</td>
							</tr>
						}
					</table>
				}

				<table class="ticket-box-table _md">
					<tr>
						<th>{{ 'PO.ORDER_TOTAL' | translate }}</th>
						<td>{{ $storage.order.printData.variables.TOTAL_AMOUNT | number:'1.2-2' }}</td>
					</tr>
					@if ($storage.order.printData.variables.ORDER_ON_THE_HOUSE == '1') {
						<tr>
							<th colspan="2">{{ 'PO.TICKET_OTH' | translate }}</th>
						</tr>
					}
					@if ($storage.order.printData.variables.TOTAL_PAYMENTS) {
						<tr>
							<th>{{ 'PO.PAID' | translate }}</th>
							<td>{{ ($storage.order.printData.variables.TOTAL_PAYMENTS - $storage.order.printData.variables.CHANGE) | number:'1.2-2' }}</td>
						</tr>
					}
					@if ($storage.order.printData.variables.TOTAL_TIPS) {
						<tr>
							<th>{{ 'PO.ORDER_TIP' | translate }}</th>
							<td>{{ $storage.order.printData.variables.TOTAL_TIPS | number:'1.2-2' }}</td>
						</tr>
					}
					@if ($storage.order.printData.variables.CHANGE) {
						<tr>
							<th>{{ 'PO.CHANGE' | translate }}</th>
							<td>{{ $storage.order.printData.variables.CHANGE | number:'1.2-2' }}</td>
						</tr>
					}
					@if ($storage.order.printData.variables.BAL_DUE !== $storage.order.printData.variables.TOTAL_AMOUNT) {
						<tr class="font-bold text-accent">
							<th>{{ 'PO.REMAINED_PAY' | translate }}</th>
							<td>{{ $storage.order.printData.variables.BAL_DUE | number:'1.2-2' }}</td>
						</tr>
					}
				</table>
			</div>

		} @else {
			<div class="ticket-box">
				<table class="ticket-box-table _md">

					@if (args.totalDiscounts) {
						<tr>
							<th>{{ 'Subtotal before discount' | translate }}</th>
							<td>{{ $storage.order.printData.variables.INCLUSIVE_GROSS_AMOUNT | number:'1.2-2' }}</td>
						</tr>
						<tr>
							<th>{{ 'Discount' | translate }}</th>
							<td>{{ (args.totalDiscounts * -1) | number:'1.2-2' }}</td>
						</tr>
					}

					<tr>
						<th>{{'Subtotal' | translate}}</th>
						<td>{{$storage.order.printData.variables.INCLUSIVE_NET_AMOUNT | number:'1.2-2'}}</td>
					</tr>

					@if ($storage.order.fees) {
						<tr>
							<th>{{ 'Fees' | translate }}</th>
							<td>{{ $storage.order.fees | number:'1.2-2' }}</td>
						</tr>
					}
					@if ($storage.order.autoGratuity) {
						<tr>
							<th>{{ $storage.order.autoGratuity.name }}</th>
							<td>{{ $storage.order.autoGratuity.amount | number:'1.2-2' }}</td>
						</tr>
					}
					@if ($storage.order.totals.totalExcludedTax) {
						<tr>
							<th>
								{{ 'Sales Tax' | translate }}
							</th>
							<td>
								{{ ($storage.order.totals.totalExcludedTax / 100) | number:'1.2-2' }}
							</td>
						</tr>
					}
					@if (args.totalTips) {
						<tr>
							<th>{{ 'PO.ORDER_TIP' | translate }}</th>
							<td>{{ args.totalTips | number:'1.2-2' }}</td>
						</tr>
					}
					<tr class="font-bold">
						<th>{{'PO.ORDER_TOTAL' | translate}}</th>
						<td>{{$storage.order.printData.variables.TOTAL_AMOUNT | number:'1.2-2'}}</td>
					</tr>
					@if ($storage.order.printData.variables.ORDER_ON_THE_HOUSE == '1') {
						<tr>
							<th colspan="2">{{ 'PO.TICKET_OTH' | translate }}</th>
						</tr>
					}
					@if ($storage.order.printData.variables.TOTAL_PAYMENTS) {
						<tr>
							<th>{{ 'PO.PAID' | translate }}</th>
							<td>{{ ($storage.order.printData.variables.TOTAL_PAYMENTS - $storage.order.printData.variables.CHANGE) | number:'1.2-2' }}</td>
						</tr>
					}
					@if ($storage.order.printData.variables.CHANGE) {
						<tr>
							<th>{{ 'PO.CHANGE' | translate }}</th>
							<td>{{ $storage.order.printData.variables.CHANGE | number:'1.2-2' }}</td>
						</tr>
					}
					@if ($storage.order.printData.variables.BAL_DUE !== $storage.order.printData.variables.TOTAL_AMOUNT) {
						<tr class="font-bold">
							<th>{{ 'PO.REMAINED_PAY' | translate }}</th>
							<td>{{ $storage.order.printData.variables.BAL_DUE | number:'1.2-2' }}</td>
						</tr>
					}
				</table>
			</div>
		}

		@if ($storage.order.payments?.length) {
			<div class="ticket-box">
				<div class="hr-label">
					<div>
						<div>{{ 'received_payments' | translate }}</div>
					</div>
				</div>
				<table class="ticket-box-table" style="margin-bottom:10px;"
					   [ngClass]="$storage.order.payments.length > 1 ? '_sm' : '_md'">
					@for ( pm of $storage.order.payments ; track pm) {
						<tr>
							<th style="vertical-align:top" class="text-near">
								<div class=" mr-2">{{ pm.name | translate }}</div>
							</th>
							<td style="vertical-align:top">
								<small class="inline mr-2" *ngIf="pm.tip">
									(<span class="inline">{{ 'gratuity' | translate }}: </span>
									{{ pm.tip | lcurrency:'1.2-2' }})
								</small>
							</td>
							<td style="vertical-align:top">{{ pm.total | lcurrency:'1.2-2' }}</td>
						</tr>
					}
				</table>
			</div>
		}
		@if ($storage.enableGratuity && workMode == 'inline' && $storage.showPrices && $storage.hasOffers && $storage.order.totalPayments) {
			<div class="tip-container text-accent" (click)="_onTicketAction('full_tip')">
				<div class="image-icon-badge mr-2">
					<mat-icon svgIcon="heart"></mat-icon>
				</div>
				<span class="_content">{{ ($storage.order.totalTips ? 'want_to_add_more_tip' : 'want_to_add_tip') | translate }}</span>
				<mat-icon svgIcon="chevron_next" class="base rotate-rtl"></mat-icon>
			</div>
		}

    </div>
</div>

@if ($storage.showPrices && $storage.hasOffers && !$storage.enablePay) {
	<div class="text-md mb-3 text-center" style="margin-top:-8px; opacity: 0.8">
		{{ 'order_payed_in_full' | translate }}
	</div>
}

<div class="order-ticket" style="padding:0 1rem">

    <div class="order-ticket-body" style="padding: 20px 20px; min-height:120px; box-shadow:none">
        <div class="ticket-box text-center">
			@if ($storage.order.printData.variables.IS_SEATED_WITHOUT_TABLE != 1) {
				<h4>{{ 'PO.TABLE_BILL' | translate }} {{ $storage.order.printData.variables.TABLE_NO }}</h4>
			} @else {
				<h4>Tab #{{$storage.order.printData.variables.ORDER_NO}}</h4>
			}
            <hr />
        </div>

		<app-tabitpay-ticket-offers></app-tabitpay-ticket-offers>
    </div>
</div>

<div class="ticket-box-powered">
    <div class="no-wrap">Powered By</div>
    <img src="../../../assets/images/tabit_logo_allgreen.png" />
</div>


